import { ConversationThread } from '@avanta/shared/components/chat/ConversationThread';
import {
  useActiveConversation,
  useConversationsStore,
} from '@avanta/shared/stores/chat/conversations';
import { cn } from '@avanta/shared/utils/cn';
import { useIsPatientOrEmployee } from 'stores/user';
import { Header } from './components/Header';
import { InputChat } from './components/InputChat';
import { WelcomeMessage } from './components/WelcomeMessage';
import { useChatOnBoarding } from './hooks/useChatOnBoarding';

export const Conversation = (): React.ReactElement | null => {
  const isOpenInfo = useConversationsStore(state => state.isOpenInfo);
  const activeChannelId = useConversationsStore(state => state.activeChannelId);
  const activeConversation = useActiveConversation();
  const isPatientOrEmployee = useIsPatientOrEmployee();

  useChatOnBoarding(activeConversation);

  return (
    <ConversationThread
      className={cn(
        (!isOpenInfo || !activeChannelId) && 'rounded-r-lg',
        isPatientOrEmployee && 'rounded-lg'
      )}
      header={<Header />}
      welcome={<WelcomeMessage />}
      input={<InputChat />}
    />
  );
};
